import Review from './contentnav';

const SeriesReview = ({ id }) => <Review id={id} type="tv" />;

export default SeriesReview;
